import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
  Typography,
} from "@mui/material";
import { ReactComponent as CheckLogo } from "../../assets/images/check-circle.svg";
import { ReactComponent as ErrorLogo } from "../../assets/images/alert-triangle.svg";

interface ConfirmDialogProps {
  open: boolean;
  title?: string;
  message: string;
  status?: boolean; // <-- NEW: success = true , error = false
  onClose: () => void;
  onConfirm: () => void;
}

const ConfirmDialog: React.FC<ConfirmDialogProps> = ({
  open,
  title = "Notification",
  message,
  status = true,
  onClose,
  onConfirm,
}) => {
  return (
    <Dialog
      open={open}
      onClose={(event, reason) => {
        if (reason === "backdropClick") return;
        onClose();
      }}
      sx={{
        "& .MuiDialog-paper": {
          borderRadius: "12px",
          padding: "16px",
          maxWidth: "300px",
          width: "100%",
          boxShadow: "0 4px 20px rgba(0, 0, 0, 0.1)",
        },
      }}
    >
      <DialogTitle sx={{ display: "flex", justifyContent: "center", p: 0 }}>
        <Box display="flex" justifyContent="center" alignItems="center" sx={{ mt: 2 }}>
          {status ? (
            <CheckLogo style={{ width: "80px", height: "80px", color: "#4caf50" }} />
          ) : (
            <ErrorLogo style={{ width: "80px", height: "80px", color: "#ff3b3b" }} />
          )}
        </Box>
      </DialogTitle>

      <DialogContent
        sx={{ padding: "16px 24px", textAlign: "center", marginTop: "30px" }}
      >
        <Typography variant="h6" sx={{ fontWeight: 600, color: "#333" }}>
          {message}
        </Typography>
      </DialogContent>

      <DialogActions sx={{ justifyContent: "center", padding: "6px 24px" }}>
        <Button
          variant="contained"
          onClick={onConfirm}
          sx={{
            borderRadius: "8px",
            textTransform: "none",
            padding: "8px 24px",
            fontWeight: "500",
            backgroundColor: status ? "#009DFF" : "#FF3B3B",
            color: "#fff",
            "&:hover": {
              backgroundColor: status ? "#1565c0" : "#e60000",
            },
          }}
        >
          OK
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmDialog;
